export const config = {
  title: "Jeremy Zollinger | Bray Real Estate | Grand Junction, CO Realtor",
  meta: {
    description:
      "Jeremy Zollinger is your trusted real estate professional with Bray Real Estate in Grand Junction, CO. Expert guidance for buying and selling homes on Colorado's Western Slope since 1946. Serving Grand Junction, Fruita, Palisade, and surrounding areas.",
    keywords: [
      "Jeremy Zollinger Realtor",
      "Bray Real Estate",
      "Grand Junction Real Estate",
      "Western Slope Colorado Homes",
      "Fruita CO Real Estate",
      "Palisade Colorado Homes",
      "Grand Junction Realtor",
      "Colorado Real Estate Agent"
    ],
    author: "Jeremy Zollinger",
    canonicalUrl: "https://www.zollingerhome.com/",
  },
  sections: {
    header: {
      businessName: "Jeremy Zollinger",
      tagline: "Bray Real Estate",
    },
    sectionB: {
      heroTitle: "Your Guide to Colorado's Western Slope",
      heroSubtitle: "Expert Real Estate Services in Grand Junction & Beyond",
      learnAboutText: "Start Your Home Search",
      phoneNumber: "9703193851",
      phoneLabel: "(970) 319-3851",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1464146072230-91cabc968266?w=1200&q=80",
      cardData: [
        {
          title: "Local Expertise",
          description:
            "Deep knowledge of Grand Junction, Fruita, Palisade, and the entire Western Slope.",
        },
        {
          title: "Trusted Partner",
          description:
            "Part of Bray Real Estate's legacy of excellence serving Colorado since 1946.",
        },
        {
          title: "Complete Service",
          description:
            "From mountain properties to wine country homes, comprehensive real estate solutions.",
        },
      ],
      description:
        "Jeremy Zollinger is a dedicated real estate professional with Bray Real Estate, proudly serving Grand Junction, Fruita, Palisade, and Colorado's beautiful Western Slope. Your friends, your neighbors, and your guide to the Grand Valley.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "Comprehensive real estate solutions for Colorado's Western Slope. From the rugged natural beauty and amazing outdoor adventures to charming downtowns and scenic wine country, I help you find your perfect place in Grand Junction and beyond.",
      cards: [
        {
          title: "Buyer Representation",
          description:
            "Expert guidance through the entire home buying process. Access to exclusive listings and deep knowledge of Western Slope neighborhoods and communities.",
          imageSrc: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80",
          imageAlt: "Colorado mountain home",
        },
        {
          title: "Seller Services",
          description:
            "Strategic marketing and professional representation to sell your home quickly and for top dollar. Backed by Bray Real Estate's decades of local expertise.",
          imageSrc: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=600&q=80",
          imageAlt: "Home for sale",
        },
        {
          title: "Western Slope Specialist",
          description:
            "From Grand Junction to Palisade wine country, Fruita outdoor recreation, and everything in between. Local knowledge you can trust.",
          imageSrc: "https://media.istockphoto.com/id/95505778/photo/suburban-america.jpg?s=612x612&w=0&k=20&c=lFK5C5EDSTHhPoDwGB21stpHK0DRSCi0uGuHuBArHjk=",
          imageAlt: "Western Slope Colorado landscape",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "First-Time Homebuyer Assistance",
        "Relocation Services",
        "Investment Property Guidance",
        "Market Analysis & Home Valuation",
        "New Construction Representation",
        "Luxury Home Marketing",
      ],
    },
    sectionD: {
      aboutTitle: "About Jeremy Zollinger",
      aboutImage: {
        src: "https://www.zollingerhome.com/wp-content/uploads/sites/25339/2025/09/Jeremy-Zollinger-450x450.png",
        alt: "Western Slope Colorado mountains",
      },
      aboutText: [
        "Jeremy Zollinger is a passionate real estate professional serving Grand Junction and Colorado's Western Slope with Bray Real Estate. With a commitment to excellence and client-focused service, Jeremy helps buyers and sellers navigate the unique real estate opportunities that make this region so special.",
        "As part of Bray Real Estate, a company with a legacy dating back to 1946, Jeremy combines modern technology and innovative marketing with time-tested local expertise. Bray Real Estate is a member of Leading Real Estate Companies of the World, providing both local knowledge and global reach.",
        "From the rugged natural beauty and amazing outdoor adventures to the charming downtowns and scenic wine country of Palisade, the Western Slope of Colorado has something for everyone. Whether you're looking for your first home, upgrading to your dream property, or relocating to this beautiful region, Jeremy provides the personalized service and market knowledge you need to succeed.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Jeremy Zollinger - Bray Real Estate Realtor",
      businessName: "Jeremy Zollinger",
      subtitle: "Bray Real Estate",
      contact: {
        phone: "9703193851",
        phoneLabel: "(970) 319-3851",
        email: "jzollinger@brayandco.com",
        website: "https://www.zollingerhome.com/",
        address: "1015 N 7th Street, Grand Junction, CO 81501",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/BrayRealLife/",
        instagram: "https://www.instagram.com/zollingerjeremy/",
        linkedIn: "https://www.linkedin.com/in/jeremy-zollinger-b17b22a3/",
        twitter: null,
      },
    },
    sectionF: {
      address: "1015 N 7th Street, Grand Junction, CO 81501",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3077.234!2d-108.5498!3d39.0739!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87472e7e7e7e7e7e%3A0x1234567890abcdef!2s1015%20N%207th%20St%2C%20Grand%20Junction%2C%20CO%2081501!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;